module.exports = __webpack_public_path__ + "static/img/bg_12.76715189.png";